// @ts-nocheck
import React, { useState, useRef, useCallback } from 'react';
import classNames from 'classnames';
import TabContext from '../TabContext';
import styles from '../style.module.css';

function Tabs(props : any) {
  const {
    className,
    defaultActiveTab,
    onTabChange,
    children,
    idPrefix,
  } = props;

  const [activeTab, setActiveTab] = useState(defaultActiveTab);

  const panelRefs = useRef([]);
  const tabRefs = useRef([]);

  const switchTab = useCallback((newActiveTab) => {
    if (activeTab !== newActiveTab) {
      setActiveTab(newActiveTab);
      tabRefs.current[newActiveTab].focus();

      if (onTabChange) onTabChange(newActiveTab);
    }
  }, [activeTab, onTabChange]);

  const handleTabKeyDown = useCallback((event, tabIndex) => {
    let newActiveTab = null;

    switch (event.key) {
      case 'Down':
      case 'ArrowDown':
        panelRefs.current[tabIndex].focus();
        break;
      case 'Left':
      case 'ArrowLeft':
        newActiveTab = tabIndex - 1;

        newActiveTab = newActiveTab < 0 ? tabRefs.current.length - 1 : newActiveTab;
        break;
      case 'Right':
      case 'ArrowRight':
        newActiveTab = tabIndex + 1;

        newActiveTab = newActiveTab > tabRefs.current.length - 1 ? 0 : newActiveTab;
        break;
      default:
        break;
    }

    if (newActiveTab !== null) {
      event.preventDefault();

      switchTab(newActiveTab);
    }
  }, [switchTab]);

  const assignRefToPanel = useCallback((node) => {
    panelRefs.current.push(node);
  }, []);

  const assignRefToTab = useCallback((node) => {
    tabRefs.current.push(node);
  }, []);

  const childrenProps = {
    activeTab,
    handleTabClick: switchTab,
    handleTabKeyDown,
    assignRefToPanel,
    assignRefToTab,
    idPrefix,
  };

  return (
    <TabContext.Provider value={childrenProps}>
      <div className={classNames(styles.tabs, className)}>{children}</div>
    </TabContext.Provider>
  );
}

Tabs.defaultProps = {
  className: '',
  defaultActiveTab: 0,
  onTabChange: undefined,
  idPrefix: 'page-tabs',
};

export default Tabs;
